/* eslint-disable @typescript-eslint/no-unnecessary-condition */
export const objToStr = (obj: Record<string, string>, delimiter = '&') => {
  if (!obj) {
    return '';
  }
  const attrs = [];
  for (const [key, value] of Object.entries(obj)) {
    attrs.push(`${key}=${value.replace(/"/g, "'")}`);
  }
  return attrs.join(delimiter);
};
